import { render, staticRenderFns } from "./NewIndustrialPropertyForm.vue?vue&type=template&id=7f371fbe"
import script from "./NewIndustrialPropertyForm.vue?vue&type=script&lang=js"
export * from "./NewIndustrialPropertyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports